// extracted by mini-css-extract-plugin
export default {"stripeFormContainer":"StripeCheckoutForm_stripeFormContainer__2XC7H"};